import { FormBuilder } from "components/FormBuilder/FormBuilder";
import React from 'react'
import { useTranslation } from "react-i18next";

/**
 * @param {Object} props 
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {boolean} props.isCreate
 * @param {boolean} props.isEditing
 * @param {boolean} props.isLoading
 */
const OnlineMerchantManagementPaymentConfigSection = ({
  formProps,
  isCreate,
  isEditing,
  isLoading
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.merchant.paymentConfigSection" });
  const { t: tCommon } = useTranslation();

  const isDisabled = isLoading;
  const isReadOnly = !isCreate && !isEditing;

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    siteId: {
      fieldType: "textInput",
      fieldName: "siteId",
      label: tLocal("label.siteId"),
      disabled: isDisabled,
      readOnly: isReadOnly,
    },
    wechatSubAppId: {
      fieldType: "textInput",
      fieldName: "wechatSubAppId",
      label: tLocal("label.wechatSubAppId"),
      disabled: isDisabled,
      readOnly: isReadOnly,
    },
    wechatSubMerchantId: {
      fieldType: "textInput",
      fieldName: "wechatSubMerchantId",
      label: tLocal("label.wechatSubMerchantId"),
      disabled: isDisabled,
      readOnly: isReadOnly,
    },
    tokenPoolMid: {
      fieldType: "textInput",
      fieldName: "tokenPoolMid",
      label: tLocal("label.tokenPoolMid"),
      subLabel: tLocal("subLabel.tokenPoolMid"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        rules: ["onlyInteger"]
      }
    },
  }

  return (
    <FormBuilder.Section
      title={tLocal("title")}
      titleVariant="h3"
    >
      <FormBuilder.Row itemsPerRow={2}>
        {
          FormBuilder.buildFields({
            formProps,
            t: tCommon,
            fields: Object.values(fieldsConfig)
          })
        }
      </FormBuilder.Row>
    </FormBuilder.Section>
  )
}


export default OnlineMerchantManagementPaymentConfigSection